import React from "react";
import PropTypes from "prop-types";
import { Card, Table, Select, Row, Col, InputNumber } from "antd";
import { CONSTITUTION_TYPES } from "constants/enums";
import _ from "lodash";

class ApprovalParameters extends React.Component {
    
    state = {
        updateCibilParamData: []
    }



    onValueSelect =(row, value)=>{
        let orginalData = this.props.cibilParamData;
        let data = this.props.cibilParamData["mpa_parameter"];
        data.map((item) => {
            if(item.parameter == row.parameter){
                item.value = value;
            }
        });
        orginalData["mpa_parameter"] = data;
        this.setState({
            updateCibilParamData: orginalData  
        });
    }

    render() {
        let cibil_parameter = this.props.cibilParamData && this.props.cibilParamData['mpa_parameter'];

        return (
            <React.Fragment>
                <Card title={"Approval Parameter"}
                    className={"padless-card small-card-title"}
                    extra={
                        <a
                            key={"icon"}
                            onClick={() => this.props.update(this.state.updateCibilParamData)}
                            disabled={this.props.recreditViewOnlyPermission}
                        >
                            {" "}
                            Update
                        </a> 
                    }>
                    <Row gutter={16} className="p-10">
                        {
                            cibil_parameter?.map((item, key) => {
                                return (

                                    <Col span={6} className="mt-10">

                                        <h5>{item?.parameter}</h5>
                                        <Select key={key} style={{ width: '90%' }} defaultValue={item.value} onChange={(value) => this.onValueSelect(item, value)}>
                                            {item.dropdown.map(_ => <Select.Option value={_}>{_}</Select.Option>)}
                                        </Select>
                                    </Col>

                                );
                            })
                        }
                    </Row>
                </Card>
                
            </React.Fragment>
        );
    }
}

ApprovalParameters.propTypes = {
    cibilParamData: PropTypes.array
};

export default (ApprovalParameters);
